module.exports = __webpack_public_path__ + "static/media/example.0b0330f2.png";